import {NativeTouchableOpacity} from '@/components/basic/touchable-opacity';
import DetailNavTitle from '@/components/business/detail-nav-title';
import {goBack} from '@/utils';
import React from 'react';
import Text from '@/components/basic/text';
import TriangleIcon from '@/components/svgs/basic/triangle';
import {View} from 'react-native';
import theme from '@/style';

export interface NavHeaderProps {
  selectName?: string;
  onChange?: () => void;
  disabled?: boolean;
}

const NavHeader = ({selectName = '', onChange}: NavHeaderProps) => {
  return (
    <DetailNavTitle
      hideServer={true}
      leftNode={
        selectName ? (
          <NativeTouchableOpacity
            style={[theme.flex.row, theme.flex.centerByCol]}
            onPress={() => onChange?.()}>
            <View
              style={[
                // eslint-disable-next-line react-native/no-inline-styles
                {
                  maxWidth: 110,
                },
              ]}>
              <Text numberOfLines={1} fontFamily="fontInterBold" size="large">
                {selectName}
              </Text>
            </View>
            {
              <View style={[theme.margin.leftxxs]}>
                <TriangleIcon />
              </View>
            }
          </NativeTouchableOpacity>
        ) : null
      }
      onBack={() => goBack()}
      hideTitle
    />
  );
};

export default NavHeader;
